<template>
    <footer id="ok_footer">
      <div class="cc_kylin5_2 container">
        <ul class="cc_foot2_ul">
            <li>
                {{$t('okmain.f_copyright')}} <img src="https://www.openkylin.top/public/images/beian.png"/><span> {{$t('okmain.f_garight')}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </li>
            <li>
               <a href="https://gitee.com/openkylin" target="_blank"> {{$t('okmain.f_code')}}</a>｜<a :href="$t('okmain.openkylinmemberurl')" target="_blank"> {{$t('okmain.f_joinmember')}}</a>｜<a :href="$t('okmain.openkylinsigurl')" target="_blank"> {{$t('okmain.f_joinsig')}}</a>
            </li>
        </ul>
        
    </div>
    </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
      return {
   
         
      }
  }
  
  
}


var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?e13df0a12a7956be3546ad80669f9308";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

</script>






<style>

</style>


// WEBPACK FOOTER //
// src/components/footer.vue